import RequestBuilder from 'Resources/RequestBuilder';
import T from 'Components/Helpers/translate';
import { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import NotificationService from 'App/babel/NotificationService';
import getAngularModule from 'App/babel/angularHelpers/getAngularModule';

export default async function prospectingRefresh(
	requestBuilder: RequestBuilder,
	entity: string,
	multiSelect: MultiSelect,
	customerId: number
) {
	const MultiActions = getAngularModule('MultiActions');

	const properties = [{ name: 'Type', value: 'Refresh' }];

	try {
		const response = await MultiActions.customer(customerId).prospecting(
			entity,
			multiSelect.selected,
			properties,
			requestBuilder.build()
		);

		if (multiSelect.selected <= 10) {
			setTimeout(() => {
				NotificationService.add({
					style: NotificationService.style.SUCCESS,
					icon: 'check',
					title: 'default.saved',
					body: T('multi.prospectingRefresh.done', { count: response?.metadata?.totalChanged ?? 0 })
				});
			}, 2000);
		} else {
			NotificationService.add({
				style: NotificationService.style.SUCCESS,
				icon: 'check',
				title: 'default.saved',
				body: T('updateQued.prospectingRefresh')
			});
		}

		return response;
	} catch (e) {
		NotificationService.add({
			style: NotificationService.style.ERROR,
			icon: 'times',
			title: 'default.error',
			body: T('multi.prospectingRefresh.failed')
		});
		throw e;
	}
}
